@use '../../../scss/utility';

@use '../list-vars';
@use './item-vars';
@use './item-common';

:host {
  @include item-vars.wb-list-item-vars;
  @include item-common.wb-list-item;

  &::before {
    @include item-common.wb-list-item-marker;
  }
}

:host([size='s']) {
  @include item-vars.wb-list-item-s-vars;

  &::before {
    @include item-common.wb-list-item-size-s;
  }

  slot[name='icon']::slotted(.wb-icon) {
    @include item-common.wb-list-item-size-s-icon;
  }
}

:host([size='s'][static]) {
  &::before {
    @include item-common.wb-list-item-size-s-static;
  }
}

:host([size='m']) {
  @include item-vars.wb-list-item-m-vars;

  &::before {
    @include item-common.wb-list-item-size-m;
  }

  slot[name='icon']::slotted(.wb-icon) {
    @include item-common.wb-list-item-size-m-icon;
  }
}

:host([size='m'][static]) {
  &::before {
    @include item-common.wb-list-item-size-m-static;
  }

  slot[name='icon']::slotted(.wb-icon) {
    @include item-common.wb-list-item-size-m-static-icon;
  }
}

:host([size='l']) {
  @include item-vars.wb-list-item-l-vars;

  &::before {
    @include item-common.wb-list-item-size-l;
  }

  slot[name='icon']::slotted(.wb-icon) {
    @include item-common.wb-list-item-size-l-icon;
  }
}

:host([size='l'][static]) {
  &::before {
    @include item-common.wb-list-item-size-l-static;
  }

  slot[name='icon']::slotted(.wb-icon) {
    @include item-common.wb-list-item-size-l-static-icon;
  }
}

::slotted(.wb-list) {
  @include list-vars.wb-list-second-level-vars;
  @include item-common.wb-list-item-nested-list;
}

:host(:first-child) {
  @include item-common.wb-list-item-first;
}

:host([variant='unordered'])::before {
  @include item-common.wb-list-item-unordered-marker;
}

:host([variant='numbered'])::before {
  @include item-common.wb-list-item-numbered-marker;
}

:host([variant='alphabetical'])::before {
  @include item-common.wb-list-item-alphabetical-marker;
}

:host(.has-icon)::before {
  display: none;
}

slot[name='icon']::slotted(.wb-icon) {
  @include item-common.wb-list-item-icon;
}
